"use client";
import {
  slider_default
} from "./chunk-2R3S2K5U.mjs";
import "./chunk-B5EDLGDE.mjs";
import "./chunk-DARTHXYH.mjs";
import {
  useSlider
} from "./chunk-WOAYVI4K.mjs";
export {
  slider_default as Slider,
  useSlider
};
